// extracted by mini-css-extract-plugin
module.exports = {"customList":"style_customList__pL2fr"};